import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shortcut"]
  static values = { age: Number, forbidden: String, autoSaleId: Number, highlightedSaleId: Number }

  connect() {
    this.element.dataset.saleListReady = "true"
    this.visitDirection = document.documentElement.dataset.turboVisitDirection
    this.lastScrollY = window.scrollY

    if (this.hasShortcutTarget && this.upcomingElement) {
      this.scrollHandler = () => this.updateShortcut()
      window.addEventListener("scroll", this.scrollHandler, { passive: true })
    }

    if (this.forbiddenValue) this.openMinimumAge(this.forbiddenValue)
    if (this.autoSaleIdValue) requestAnimationFrame(() => this.openSale(this.autoSaleIdValue))
    if (this.highlightedSaleIdValue) requestAnimationFrame(() => this.scrollToSale(this.highlightedSaleIdValue))
  }

  disconnect() {
    if (this.scrollHandler) window.removeEventListener("scroll", this.scrollHandler)
    delete this.element.dataset.saleListReady
    delete this.element.dataset.saleListScrollReset
  }

  resetScrollAfterTurboVisit() {
    const direction = this.visitDirection
    this.visitDirection = null
    if (!direction || direction === "back") return

    window.scrollTo(0, 0)
    this.element.dataset.saleListScrollReset = "true"
  }

  verifyMinimumAge(event) {
    const link = event.currentTarget
    const minimumAge = Number.parseInt(link.dataset.minimumAge, 10)
    if (!Number.isFinite(minimumAge) || this.ageValue >= minimumAge) return

    event.preventDefault()
    this.openMinimumAge(link.dataset.id)
  }

  toggleCaption(event) {
    event.preventDefault()
    event.stopPropagation()
    const caption = event.currentTarget.closest(".caption")
    caption?.classList.toggle("full")
    caption?.closest(".item")?.classList.toggle("item-full")
  }

  dismiss(event) {
    event.preventDefault()
    event.currentTarget.closest(".sale_redirect_msg")?.remove()
  }

  scrollToUpcoming(event) {
    event.preventDefault()
    if (!this.upcomingElement) return

    this.isScrollingToUpcoming = true
    this.shortcutTarget.classList.remove("open")
    window.scrollTo({
      top: this.upcomingTop(),
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    })
  }

  updateShortcut() {
    const currentScrollY = window.scrollY
    const delta = currentScrollY - this.lastScrollY
    this.lastScrollY = currentScrollY

    if (this.isScrollingToUpcoming) {
      this.shortcutTarget.classList.remove("open")
      if (currentScrollY >= this.upcomingTop() - 1 || delta < 0) this.isScrollingToUpcoming = false
      return
    }

    if (currentScrollY >= this.upcomingTop() - 1) {
      this.shortcutTarget.classList.remove("open")
    } else if (delta > 70) {
      this.shortcutTarget.classList.add("open")
    } else if (delta < -70) {
      this.shortcutTarget.classList.remove("open")
    }
  }

  openSale(id) {
    this.element.querySelector(`a.item-link[data-id="${CSS.escape(String(id))}"]`)?.click()
  }

  scrollToSale(id) {
    const sale = document.getElementById(`sale_${id}`)
    if (sale) window.scrollTo(0, sale.offsetTop - 130)
  }

  openMinimumAge(saleId) {
    const modal = document.getElementById(`require_age_${saleId}`)
    if (!modal) return

    modal.classList.add("open")
    const birthdayForm = modal.querySelector(".birthday-form")
    if (birthdayForm) birthdayForm.hidden = this.ageValue > 0
  }

  upcomingTop() {
    if (!this.upcomingElement) return 0

    const headerHeight = document.querySelector("body > header, body header")?.getBoundingClientRect().height || 0
    const marginTop = Number.parseFloat(getComputedStyle(this.upcomingElement).marginTop) || 0
    return this.upcomingElement.offsetTop - headerHeight - marginTop
  }

  get upcomingElement() {
    return this.element.querySelector(".wrapper.upcoming")
  }
}
